import { render, staticRenderFns } from "./CustomerAccounts.vue?vue&type=template&id=2afcba1d&"
import script from "./CustomerAccounts.vue?vue&type=script&lang=js&"
export * from "./CustomerAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports